<template>
  <div>
    <LmComponentLoading v-if="isDataProcessing" />
    <LmListV2 ref="LmListV2"
    v-if="!isDataProcessing"
    :isGraphql="true"
    :gqlField="gqlField"
    :gqlVariables="gqlVariables"
    :gqlQuery="gqlQuery"
    :searchOnFieldsSelected="searchOnFieldsSelected"
    :searchOnFieldsToSelected="searchOnFieldsToSelected"
    :allAvailableFields="allAvailableFields"
    :mode="mode"
    />
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import LmListV2 from '@/components/LmListV2'

export default {
  data () {
    return {
      gqlField: '',
      gqlQuery: '',
      gqlVariables: '',
      searchOnFieldsSelected: '',
      searchOnFieldsToSelected: '',
      allAvailableFields: [],
      form: { newFields: {} },
      mode: {
        table: true,
        map: false
      },
      isDataProcessing: true
    }
  },
  components: {
    LmListV2
  },
  methods: {
    async getListValues () {
      try {
        this.isDataProcessing = true
        const endPoint = await commonsApi.axiosGetWrapper(`listbuilder/${this.$route.params.id}`)
        this.gqlField = endPoint.data.gqlField
        this.gqlQuery = endPoint.data.gqlQuery
        this.gqlVariables = endPoint.data.gqlVariables
        this.searchOnFieldsSelected = endPoint.data.searchOnFieldsSelected
        this.searchOnFieldsToSelected = endPoint.data.searchOnFieldsToSelected
        this.allAvailableFields = endPoint.data.fields
        this.mode = endPoint.data.mode
      } catch (error) {
        console.log(error)
      } finally {
        this.isDataProcessing = false
      }
    }
  },
  watch: {
    '$route.params.id' () {
      this.getListValues()
    }
  },
  created () {
    this.getListValues()
  }
}
</script>

<style>

</style>
